import "./productpage.css";
import Productpagetopheader from "./productpagetopheader";
import Productpageinfo from "./productpageinfo";
import { useParams } from "react-router-dom";
import { useProducts } from "../../context/ProductsContext";
import { useState, useEffect } from "react";

export default function Productpage({ wishlist, setWishlist, cartlist, setcartlist }) {
    // 1. جلب البيانات والحالة من Context
    const { productsdata, loading } = useProducts();
    const { id } = useParams();

    const [product, setProduct] = useState(null);
    const [error, setError] = useState(null);


    // 2. useEffect مع productsdata في الاعتماديات (هذا هو الحل الجذري!)
    useEffect(() => {
        // إذا كانت البيانات قيد التحميل، انتظر
        if (loading || !productsdata || productsdata.length === 0) {
            return; // اخرج بدون تعيين error
        }

        // البحث عن المنتج (مقارنة آمنة بين string و number)
        const foundProduct = productsdata.find(
            (item) => item.id.toString() === id.toString()
        );

        if (foundProduct) {
            setProduct(foundProduct);
            setError(null);
        } else {
            console.warn("⚠️ [25] Productpage: المنتج غير موجود في البيانات:", id);
            setError("المنتج غير موجود");
            setProduct(null);
        }
    }, [id, productsdata, loading]); // ✅ إضافة productsdata و loading هنا
    // 🔹 أولاً: فحص الخطأ (إذا حدث خطأ في الاتصال)
    if (error) {
        return (
            <div className="product-page">
                <Productpagetopheader
                    wishlist={wishlist}
                    setWishlist={setWishlist}
                    cartlist={cartlist}
                    setcartlist={setcartlist}
                />
                <div className="error-container">
                    <h2>حدث خطأ في الاتصال</h2>
                    <p>{error.message}</p>
                    <a href="/" className="back-to-home">الرجوع للرئيسية</a>
                </div>
            </div>
        );
    }

    // 🔹 ثانياً: فحص التحميل (بعد التأكد من عدم وجود خطأ)
    if (loading || !productsdata || productsdata.length === 0) {
        return (
            <div className="product-page">
                <Productpagetopheader
                    wishlist={wishlist}
                    setWishlist={setWishlist}
                    cartlist={cartlist}
                    setcartlist={setcartlist}
                />
                <div className="loading-container">
                    <p>⏳ جاري تحميل بيانات المنتج...</p>
                </div>
            </div>
        );
    }

    // 🔹 ثالثاً: التأكد من وجود المنتج (بعد نجاح التحميل)
    if (!product) {
        return (
            <div className="product-page">
                <Productpagetopheader
                    wishlist={wishlist}
                    setWishlist={setWishlist}
                    cartlist={cartlist}
                    setcartlist={setcartlist}
                />
                <div className="error-container">
                    <h2>المنتج غير موجود</h2>
                    <p>عذرًا، المنتج الذي تبحث عنه غير موجود أو تم إزالته.</p>
                    <a href="/" className="back-to-home">العودة للصفحة الرئيسية</a>
                </div>
            </div>
        );
    }

    // 5. عرض المنتج بنجاح
    return (
        <div className="product-page">
            <Productpagetopheader
                wishlist={wishlist}
                setWishlist={setWishlist}
                cartlist={cartlist}
                setcartlist={setcartlist}
            />
            <Productpageinfo
                product={product}
                cartlist={cartlist}
                setcartlist={setcartlist}
            />
        </div>
    );
}